import React from "react";
import LinkedEntityCollapseList from "@common/components/linkedEntityCollapseList/LinkedEntityCollapseList.tsx";
import { useTranslation } from "@localization/useTranslation.ts";
import { useProcessLegalEntitiesField } from "./ProcessLegalEntitiesField.hooks.ts";

export interface ProcessLegalEntitiesFieldProps {
    legalEntityIds: Array<string>;
    onChange: (legalEntityIds: Array<string>) => void;
    disabled: boolean;
    isPreview: boolean;
    errorText?: string;
}

function ProcessLegalEntitiesField(props: ProcessLegalEntitiesFieldProps) {
    const { translateString } = useTranslation();
    const { isLoading, data, getLinkTo, getSubContractors, isSubContractorsLoading } = useProcessLegalEntitiesField(props);

    return (
        <LinkedEntityCollapseList
            header={translateString("processLegalEntitiesHeader")}
            selectedIds={props.legalEntityIds}
            selectableItems={data}
            onChange={props.onChange}
            getLinkTo={getLinkTo}
            details={{
                label: translateString("subContractors"),
                toolTip: translateString("legalEntitySubContractorsToolTip"),
                getValues: getSubContractors,
                isLoading: isSubContractorsLoading,
            }}
            addButtonText={translateString("addLegalEntity")}
            removeItemText={translateString("removeLegalEntity")}
            selectLabel={translateString("legalEntity")}
            disabled={props.disabled}
            isLoading={isLoading}
            isPreview={props.isPreview}
            errorText={props.errorText}
        />
    );
}

export default ProcessLegalEntitiesField;
